import { useSyncExternalStore } from 'react';

// How each person likes to read the list, remembered by the browser: the clock, wrapping, request dumps. A setting is
// a convenience: storage may be missing (a private window) and the defaults then hold.
export interface Settings {
    timeZone: 'rome' | 'utc';
    wrap: boolean;
    showRequests: boolean;
}

const KEY = 'fl.settings';
const DEFAULTS: Settings = { timeZone: 'rome', wrap: false, showRequests: false };

function load(): Settings {
    try {
        const stored = JSON.parse(localStorage.getItem(KEY) ?? '{}') as Partial<Settings>;

        return { ...DEFAULTS, ...stored };
    } catch {
        return DEFAULTS;
    }
}

let current = load();
const listeners = new Set<() => void>();

export function updateSettings(patch: Partial<Settings>): void {
    current = { ...current, ...patch };
    try {
        localStorage.setItem(KEY, JSON.stringify(current));
    } catch {
        // Not remembered, still applied.
    }
    listeners.forEach((listener) => listener());
}

const subscribe = (listener: () => void): (() => void) => {
    listeners.add(listener);

    return () => listeners.delete(listener);
};

export const useSettings = (): Settings => useSyncExternalStore(subscribe, () => current);
